<h2 mat-dialog-title class="mb-3">{{data ? ('EditPrompt' | translate) : ('NewPrompt' | translate)}}</h2>
<mat-dialog-content class="mat-typography">
    <div class="dialog-split-container">
        <!-- Left side: Prompt Form -->
        <div class="prompt-form-section">
            <form [formGroup]="promptForm" class="prompt-form">
                <mat-form-field appearance="outline">
                    <mat-label>{{ 'PromptTitle' | translate }}</mat-label>
                    <input matInput formControlName="title" required> @if (promptForm.get('title')?.hasError('required')) {
                    <mat-error>
                        {{ 'TitleRequired' | translate }}
                    </mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{ 'PromptContext' | translate }}</mat-label>
                    <textarea matInput formControlName="context" required rows="3"></textarea> @if (promptForm.get('context')?.hasError('required')) {
                    <mat-error>
                        {{ 'ContextRequired' | translate }}
                    </mat-error>
                    }
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{ 'PromptDetails' | translate }}</mat-label>
                    <textarea matInput formControlName="details" required rows="15"></textarea> @if (promptForm.get('details')?.hasError('required')) {
                    <mat-error>
                        {{ 'DetailsRequired' | translate }}
                    </mat-error>
                    }
                </mat-form-field>
                <small class="hint-text">
                    {{ 'ContractDataHint' | translate }}
                </small>
            </form>
        </div>

        <!-- Right side: Test Area -->
        <div class="test-section">
            @if (canTest) {
            <h4>{{ 'TestThisPrompt' | translate }}</h4>

            <div class="upload-section">
                @if (testWorkflowId) {
                <shared-upload [workflowId]="testWorkflowId" workflowType="documents" [fileList]="testFileList" [fileLimit]="5" [fileFormats]="fileFormats" (fileProcessEvent)="onTestFileProcessed($event)" (deleteFileEvent)="onTestFileDeleted($event)">
                </shared-upload>
                } @else if (isInitializingWorkspace) {
                <p>{{ 'InitializingTestWorkspace' | translate }}</p>
                } @else if (workspaceInitializationError) {
                <div class="error-message">
                    <p>{{ 'WorkspaceInitializationError' | translate }}</p>
                    <button mat-button color="primary" (click)="retryWorkspaceInitialization()">{{ 'Retry' | translate }}</button>
                </div>
                } @else {
                <p>{{ 'ReadyToInitializeWorkspace' | translate }}</p>
                }
            </div>

            @if (hasTestFiles) {
            <div class="test-actions" style="display: flex; align-items: center; gap: 12px;">
                <button mat-raised-button color="accent" [disabled]="!promptForm.valid || isSubmitting || isTestingPrompt" (click)="onSubmit(true)">
                    {{ 'Test' | translate }}
                </button> @if (isSubmitting || isTestingPrompt) {
                <div class="custom-spinner"></div>
                }
            </div>
            } @if (testResults && testResults.length > 0) {
            <div class="test-results">
                <h5>{{ 'TestResults' | translate }}:</h5>
                @for (result of testResults; track result.file) {
                <mat-expansion-panel class="result-panel">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <mat-icon>description</mat-icon>
                            {{result.file}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="result-content">
                        @if (getParsedResult(result.promptResult); as parsedResult) {
                        <ul class="result-list">
                            @if (parsedResult.short_answer) {
                            <li>
                                <strong>Answer:</strong> {{ parsedResult.short_answer }}
                            </li>
                            } @if (parsedResult.summary) {
                            <li>
                                <strong>Summary:</strong>
                                <div class="result-content-item">
                                    <markdown [data]="parsedResult.summary"></markdown>
                                </div>
                            </li>
                            } @if (parsedResult.passage) {
                            <li>
                                <strong>Relevant Passage:</strong>
                                <div class="result-content-item">
                                    <markdown [data]="parsedResult.passage"></markdown>
                                </div>
                            </li>
                            }
                        </ul>
                        } @else {
                        <pre>{{result.promptResult}}</pre> }
                    </div>
                </mat-expansion-panel>
                }
            </div>
            } } @else {
            <div class="test-placeholder">
                <mat-icon>info</mat-icon>
                <p>{{ 'SavePromptToEnableTest' | translate }}</p>
            </div>
            }
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="center">
    <button mat-button mat-dialog-close (click)="onCancel()" [disabled]="isSubmitting">{{ 'Cancel' | translate }}</button>

    <button mat-raised-button color="primary" [disabled]="!promptForm.valid || isSubmitting" (click)="onSubmit(false)">
        <span *ngIf="!isSubmitting">{{ 'SaveAndClose' | translate }}</span>
        <mat-spinner *ngIf="isSubmitting" diameter="10" class="button-spinner"></mat-spinner>
    </button>
</mat-dialog-actions>